// extracted by mini-css-extract-plugin
export default {"input":"FormInput_input__92bY-"};